import type { Platform, PlatformFeatures } from '@exiftrator/shared';
import { createFileService } from './services/fileService';
import { createStorageService } from './services/storageService';
import { createDialogService } from './services/dialogService';
import { createBufferService } from './services/bufferService';
import { createDownloadService } from './services/downloadService';

export interface WebPlatformFeatures extends PlatformFeatures {
  serviceWorker?: ServiceWorkerRegistration;
  shareApi?: boolean;
}

export function createWebPlatform(): Platform {
  return {
    name: 'web',
    version: '1.0.0',

    file: createFileService(),
    storage: createStorageService(),
    dialog: createDialogService(),
    buffer: createBufferService(),
    download: createDownloadService(),

    capabilities: {
      hasFileSystemAccess: false,
      hasNativeDialogs: false,
      hasMenuBar: false,
      hasSystemTray: false,
      hasDragAndDrop: true,
      maxFileSize: 100 * 1024 * 1024, // 100MB for web
    },

    features: {
      shareApi: typeof navigator !== 'undefined' && 'share' in navigator,
    } as WebPlatformFeatures,
  };
}
